import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app";

import "./styles/reset.css";
import "./styles/index.css";
import "./styles/eedi.theme.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
